import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { BASE_TITLE } from '../config/constant';

/**
 * Hook para atualizar o título da página automaticamente baseado na rota
 * @param {string} customTitle - Título personalizado (opcional)
 */
const usePageTitle = (customTitle = null) => {
  const location = useLocation();

  useEffect(() => {
    // Se tem título customizado, usa ele
    if (customTitle) {
      document.title = customTitle + BASE_TITLE;
      return;
    }

    // Mapeia rotas para títulos
    const routeTitles = {
      '/': 'Dashboard',
      '/login': 'Login',
      '/cadastrar': 'Cadastrar',
      '/history/nfe': 'Histórico NF-e',
      '/history/nfce': 'Histórico NFC-e',
      '/history/nfse': 'Histórico NFS-e',
      '/history/cte': 'Histórico CT-e',
      '/history/sat': 'Histórico SAT',
      '/consulta/programada': 'Consulta Programada',
      '/consulta/manifestacao': 'Manifestação',
      '/consulta/download': 'Download XML',
      '/empresas': 'Empresas',
      '/usuarios': 'Usuários',
      '/perfil': 'Perfil',
      '/editarPerfil': 'Editar Perfil',
      '/planos': 'Planos',
      '/aplicativos': 'Aplicativos',
      '/relatorios': 'Relatórios',
      '/configuracoes': 'Configurações',
      '/suporte': 'Suporte',
      '/resgate': 'Resgate XML',
      '/403': 'Acesso Negado'
    };

    // Tenta encontrar título exato
    let title = routeTitles[location.pathname];

    // Se não encontrou, tenta match parcial
    if (!title) {
      const pathSegments = location.pathname.split('/').filter(Boolean);
      
      if (pathSegments.length > 0) {
        const firstSegment = pathSegments[0];
        
        // Mapeia segmentos para títulos
        const segmentTitles = {
          'history': 'Histórico',
          'consulta': 'Consulta',
          'empresas': 'Empresas',
          'usuarios': 'Usuários',
          'relatorios': 'Relatórios',
          'aplicativos': 'Aplicativos',
          'planos': 'Planos',
          'resgate': 'Resgate XML',
          'configuracoes': 'Configurações'
        };

        title = segmentTitles[firstSegment] || 'Espião Cloud';
      }
    }

    // Atualiza o título
    document.title = (title || 'Espião Cloud') + BASE_TITLE;
  }, [location.pathname, customTitle]);
};

export default usePageTitle;
